import script from "./FiltrosParcerias.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosParcerias.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosParcerias.vue?vue&type=style&index=0&id=4d7628d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7628d0"]])

export default __exports__